import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import { Card, Container } from "react-bootstrap";
import { useAlert } from "../../../../context/AlertContext";
import { useLoading } from "../../../../context/LoadingContext";
import { addEditServiceRequest } from "../../../../commons/ServiceRequest";
import ServiceTypeForm from "../../../../components/GeneralForm/ServiceTypeForm";
import DownTimesService from "../../../../services/downtime.service";

export default function AddServiceTypeInformation() {
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const { setLoading } = useLoading();

  return (
    <>
      <Helmet>
        <title>เพิ่มข้อมูลประเภทบริการ</title>
        <meta name="description" content="Add Service Type Page" />
      </Helmet>

      <Container fluid className="p-3">
        <Card className="m-1 mb-4 p-4 border-0">
          <Card.Header className="p-3 bg-transparent border-bottom-0">
            <Card.Title className="mb-0 fs-2">
              เพิ่มข้อมูลประเภทบริการ
            </Card.Title>
          </Card.Header>

          <ServiceTypeForm
            onSubmitCallback={(data) =>
              addEditServiceRequest({
                showAlert,
                setLoading,
                serviceRequest: DownTimesService.createDownTimes(data),
                navigated: (navi) => navi && navigate(0)
              })
            }
          />
        </Card>
      </Container>
    </>
  );
}
